import $ from 'jquery';
import tingle from 'tingle.js';
import {load} from '@shopify/theme-sections';

import {FlowViewManager} from '../lib/flow-view-manager';
import {util} from '../lib/util';
import {emailAndZipSubmit} from '../lib/email-and-zip-submit';
import '../lib/slidescroll';
import '../lib/plan-selector';


import '../sections/order-confirmation';
import '../sections/meal-menu';
import '../sections/plan-selector-v2';
import '../sections/subscription-header';

window.mosaic = window.mosaic || {};
window.mosaic.views = FlowViewManager;
window.mosaic.views.init();

load(['order-confirmation', 'meal-menu', 'plan-selector-v2', 'subscription-header']);

document.addEventListener('plan-v2:selected', (e) => {
  const {response} = e.detail;
  sessionStorage.setItem('mcsp', JSON.stringify(response));
});

function openModal(content, modal) {
  // set content
  modal.setContent(content);
  modal.scrollTop = 0;
  // open modal
  modal.open();
  emailAndZipSubmit.init(modal);
}

// check availability modal
const checkAvailabilityModal = new tingle.modal({
  footer: true,
  stickyFooter: false,
  closeMethods: ['overlay', 'button', 'escape'],
  closeLabel: 'Close',
  cssClass: ['check-availability-modal', 'mosaic-modal'],
  beforeClose() {
    const zip = $('.check-availability-modal .ca-form-zip-field').val();
    const valid = util.validZip(zip);

    if (valid === null) {
      $('.zip-error').slideDown();
      return false;
    } else {
      return zip === util.getUrlParam('zip_code');
    }
  },
});

const zip = util.getUrlParam('zip_code');
// Initialize Modal
const checkAvailabilityModalContent = $('#check-availability-modal').html();

if (
  window.location.href.indexOf('meal-editor') === -1 &&
  window.location.href.indexOf('skip_meal_selector=true') === -1 &&
  window.location.href.indexOf('checkout=true') === -1 &&
  window.location.href.indexOf('flow=oneTimeToSubscription') === -1
) {
  if (!zip) {
    openModal(checkAvailabilityModalContent, checkAvailabilityModal);
  }
}
